export default Object.freeze({
  list: [],
  options: [],
  selectedClient: null,
  users: {},
  badges: {},
  clientEmailSettings: {},
  siteEmailSettings: {},
  mobilePatrolEmailSettings: {},
});
